import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { authUser } from '../../service/Auth/Auth.js';
import { getCurrentConfig } from '../../config/config.js';
import './Login.css';

const validationSchema = yup.object({
  userName: yup.string().required('Username is required'),
  password: yup.string().required('Password is required'),
});

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const config = getCurrentConfig();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    const { userName, password } = data;
    setIsLoading(true);
    setErrorMessage('');

    try {
      const loginResult = await authUser(userName, password);
      
      if (loginResult === 200) {
        navigate('/dashboard');
      } else {
        setErrorMessage('Login failed. Please check your credentials.');
      }
    } catch (error) {
     
      setErrorMessage('Login failed. Please check your credentials.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-bg login-bg-animated" style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('${config.loginImage}')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <div className="card" style={{ 
        width: '100%', 
        maxWidth: '400px', 
        margin: '20px',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        border: '1px solid rgba(255, 255, 255, 0.2)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{ 
            color: config.primaryColor, 
            fontSize: '2.5rem', 
            marginBottom: '5px',
            fontWeight: 'bold',
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
          }}>
            {config.applicationName}
          </h1>
        </div>

        {errorMessage && (
          <div className="alert alert-error">
            {errorMessage}
          </div>
        )}

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label className="form-label" htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              autoComplete="username"
              className="form-input"
              {...register('userName')}
              placeholder="Enter your username"
            />
            {errors.userName && (
              <div className="form-error">{errors.userName.message}</div>
            )}
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="password">Password</label>
            <input
              type="password"
               id="password"
              className="form-input"
              {...register('password')}
              placeholder="Enter your password"
            />
            {errors.password && (
              <div className="form-error">{errors.password.message}</div>
            )}
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ 
              width: '100%', 
              backgroundColor: config.primaryColor,
              borderColor: config.primaryColor,
              fontSize: '1.1rem',
              fontWeight: '600',
              padding: '12px',
              borderRadius: '8px',
              border: 'none',
              color: '#1a1a1a',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            disabled={isLoading}
            onMouseOver={(e) => {
              if (!isLoading) {
                e.target.style.backgroundColor = '#b8976a';
                e.target.style.transform = 'translateY(-1px)';
              }
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = config.primaryColor;
              e.target.style.transform = 'translateY(0)';
            }}
          >
            {isLoading ? (
              <>
                <div 
                  className="spinner" 
                  style={{ 
                    width: '16px', 
                    height: '16px', 
                    borderWidth: '2px' 
                  }}
                ></div>
                Signing in...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
